<template>
  <div id="app" class="bg-gray-800  min-h-screen h-full">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
